import { render, staticRenderFns } from "./InvoiceTypesPage.vue?vue&type=template&id=ffec5a6c&scoped=true&"
import script from "./InvoiceTypesPage.vue?vue&type=script&lang=ts&"
export * from "./InvoiceTypesPage.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceTypesPage.vue?vue&type=style&index=0&id=ffec5a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffec5a6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VIcon,VSwitch,VTooltip})
